import React, { useState } from 'react';
import 'react-pdf/dist/esm/Page/AnnotationLayer.css'; 
import { Document, Page, pdfjs } from 'react-pdf';
import 'react-pdf/dist/esm/Page/AnnotationLayer.css';
import 'react-pdf/dist/esm/Page/TextLayer.css';

pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.js`;

const PdfPreview = ({ file }) => {
    const [numPages, setNumPages] = useState(null);

    function onDocumentLoadSuccess({ numPages }) {
        setNumPages(numPages);
      }
    
    return (
      <div className='docContainer'>
          <Document
              file={file}
              onLoadSuccess={onDocumentLoadSuccess}
          >
              {Array.from(new Array(numPages), (el, index) => (
                  <div key={`page_${index + 1}`} className="docview">
                      <Page 
                          pageNumber={index + 1} 
                          width={window.innerWidth * 0.8} 
                          className="pageView"
                      />
                      {index < numPages - 1 && <hr className='borderDoc' />}
                  </div>
              ))}
          </Document>
  </div>
    );
};

export default PdfPreview;